export class spoSiteOwnershipChange {
    public siteUrl: string = "";
    public newOwnerEmail: string = "";
  }